/** 
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Leaving form confirmation dialog
  Date: July 6, 2020
**/

import React from 'react'
import {
  Dialog,
  DialogContent,
  Button,
  Grid,
  Divider,
  DialogActions,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import {Prompt} from 'react-router-dom';
import { MESSAGE } from '../constants/applicationConstants';

const CustomModal = (props) => {
  const {visible, onCancel, onConfirm} = props;
  return <Dialog
    open={visible}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    maxWidth='sm'
    class="IHAlertDialog"
    PaperProps={{
      style: { borderRadius: 20 }
    }}
  >
    <DialogTitle id="alert-dialog-title" sx={{
      "& .MuiDialogTitle-root": {
        justifyContent: "flex-start",
        alignItems: "flex-start"
      }
    }}>
      {MESSAGE.unsavedFormLeaveHead}
    </DialogTitle>
    <Divider />
    <DialogContent>
      <DialogContentText id="alert-dialog-description" >
        {MESSAGE.unsavedFormLeave}
      </DialogContentText>
    </DialogContent>
    <DialogActions >
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        <Grid item>
          <Button onClick={onConfirm} variant="contained" color="secondary">
            Leave
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={onCancel} variant="contained" color="primary" autoFocus>
            Stay
          </Button>
        </Grid>
      </Grid>
    </DialogActions>
  </Dialog>
}

export class RouteLeavingGuard extends React.Component {    
  state = {
    modalVisible: false,
    lastLocation: null,
    confirmedNavigation: false,
  }
  showModal = (location) => this.setState({
    modalVisible: true,
    lastLocation: location,
  })
  closeModal = (callback) => this.setState({
    modalVisible: false
  })
  handleBlockedNavigation = (nextLocation) => {
    const {confirmedNavigation} = this.state
    const {shouldBlockNavigation} = this.props
    if (!confirmedNavigation && shouldBlockNavigation(nextLocation)){
      this.showModal(nextLocation)
      return false
    }   
    return true
  }
  handleConfirmNavigationClick = () => {
    const {navigate} = this.props
    const {lastLocation} = this.state
    if (lastLocation) {
      this.setState({
        confirmedNavigation: true,
        modalVisible: false
      }, () => {
        // Navigate to the previous blocked location with your navigate function     
        navigate(lastLocation.pathname)
      })
    }
  }
  render() {    
    const {when} = this.props
    const {modalVisible} = this.state
    return (
      <>
        <Prompt
          when={when}
          message={this.handleBlockedNavigation}
        />
        <CustomModal
          visible={modalVisible}
          onCancel={this.closeModal}
          onConfirm={this.handleConfirmNavigationClick}
        />
      </>
    )
  }
}
export default RouteLeavingGuard